var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetupIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.139 4.827L8.5 1.155l6.361 3.672v7.346L8.5 15.845l-6.361-3.672V4.827z",
    stroke: "#5C7080",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 5l3.031 1.75v3.5L8.5 12l-3.031-1.75v-3.5L8.5 5z",
    fill: "#EE7E0F"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNyAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIuMTM4NzggNC44MjczNUw4LjUgMS4xNTQ3TDE0Ljg2MTIgNC44MjczNVYxMi4xNzI3TDguNSAxNS44NDUzTDIuMTM4NzggMTIuMTcyN1Y0LjgyNzM1WiIgc3Ryb2tlPSIjNUM3MDgwIiBzdHJva2Utd2lkdGg9IjIiLz4KPHBhdGggZD0iTTguNSA1TDExLjUzMTEgNi43NVYxMC4yNUw4LjUgMTJMNS40Njg5MSAxMC4yNVY2Ljc1TDguNSA1WiIgZmlsbD0iI0VFN0UwRiIvPgo8L3N2Zz4K";
export { SvgSetupIcon as ReactComponent };